import React from "react";
import HowToPay from "./howToPay";
import { useParams } from "react-router-dom";
import masterProgrammesData from "../../../../data/masterProgrammesData";

const ProgrammeFees = () => {

  const { masterProgramme } = useParams();

  const mastersprogram = masterProgrammesData.find(
    (prog) => prog.id === masterProgramme
  );

  const fees = mastersprogram?.fees || [];
  const standaloneQualificationFeesData =
    mastersprogram?.standaloneQualificationFeesData || [];
  const isStandaloneFees = mastersprogram?.standaloneQualificationFees || false;

  const scholarshipData = mastersprogram?.scholarships || [];

  const totalFees = fees.reduce((total, fee) => total + fee.amount, 0);

  return (
    <div className="md:scroll-mt-44 scroll-mt-16" id="programme-fees">
      <div className="max-w-6xl mx-auto p-2 md:p-10">
        <div className="space-y-2">
          <h1 className="text-3xl font-bold">Programme Fees</h1>
          <div className="w-10 h-1 bg-black"></div>
        </div>

        <div className="mt-6">
          <p>
            The fees below relate to new students registering for the 2026–2027
            session.
          </p>

          {mastersprogram ? (
            fees.length > 0 ? (
              <table className="table-auto border-collapse border border-gray-400 w-full text-left mt-4">
                <thead>
                  <tr className="bg-black">
                    <th className="border border-gray-400 px-4 py-2 text-white">
                      Fee Description
                    </th>
                    <th className="border border-gray-400 px-4 py-2 text-white">
                      Amount (&euro;) 2026–2027
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {fees.map((fee, idx) => (
                    <tr key={idx}>
                      <td className="border border-gray-400 px-4 py-2">
                        {fee.title}
                      </td>
                      <td className="border border-gray-400 px-4 py-2">
                        {fee.amount}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tbody className="bg-sddarkgray/30 text-sddarkgray">
                  <tr>
                    <td className="border border-gray-400 px-4 py-2 font-bold">
                      Total Fees
                    </td>
                    <td className="border border-gray-400 px-4 py-2 font-bold">
                      {totalFees}
                    </td>
                  </tr>
                </tbody>
              </table>
            ) : (
              <p className="mt-4 text-red-600">
                Sorry, fees for this programme are currently not available.
              </p>
            )
          ) : (
            <p className="mt-4 text-red-600">
              Programme not found. Please check the URL or try another
              programme.
            </p>
          )}
        </div>

        {isStandaloneFees && (
          <div className="mt-6 p-4 border-2 border-sddarkgray bg-sddarkorange rounded-md">
            <h2 className="text-lg font-semibold mb-2 text-sddarbg-sddarkgray">
              Standalone Qualification Fees
            </h2>
            <p className="text-sm text-gray-700">
              The fees for standalone awards (Postgraduate Certificate or
              Postgraduate Diploma) and EUBD Route students entering Semester 3
              will be based on completed modules and a one-time registration fee
              of €150.
            </p>
            {standaloneQualificationFeesData ? (
              standaloneQualificationFeesData.length > 0 ? (
                <table className="table-auto border-collapse w-full text-left mt-4">
                  <thead>
                    <tr className="bg-black">
                      <th className="border-r border-r-white/50 px-4 py-2 text-white">
                        Award / Entry Point
                      </th>
                      <th className=" px-4 py-2 text-white">Fee (&euro;)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {standaloneQualificationFeesData.map((item, idx) => (
                      <tr key={idx}>
                        <td className="border border-sddarkgray px-4 py-2">
                          {item.title}
                        </td>
                        <td className="border border-sddarkgray px-4 py-2">
                          {item.amount}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="hidden mt-4 text-red-600">
                  Sorry, Standalone fees for this programme are currently not
                  available.
                </p>
              )
            ) : (
              <p className="mt-4 text-red-600">
                Programme not found. Please check the URL or try another
                programme.
              </p>
            )}
          </div>
        )}
      </div>

      <div>
        <HowToPay />
      </div>
      <Scholarship scholarshipData={scholarshipData} />
    </div>
  );
};

export default ProgrammeFees;

const Scholarship = ({ scholarshipData }) => {
  return (
    <div className="max-w-6xl mx-auto p-2 md:p-10">
      <div>
        <div className="flex items-center mb-4">
          <h2
            id="scholarships-heading"
            className="text-3xl font-bold text-sddarkgray"
          >
            Scholarships
          </h2>
          <div className="flex-1 h-1 ml-4 bg-sddarkgray/50 rounded"></div>
        </div>
        <div>
          <p>
            The European School of Business & Diplomacy provides scholarships to
            students who fulfil eligibility criteria while showing leadership
            potential or social impact or financial need. Students who receive
            admission to the program can apply for Emmanuel Addo Scholarship
            Project or Leadership Excellence Awards scholarships. The
            scholarship awards follow particular criteria which determine the
            selection process through merit-based evaluation and regional or
            community involvement assessment.
          </p>
        </div>

        <div className="mt-6">
          <p>
            The European School of Business & Diplomacy offers a range of
            scholarships to support access and recognise excellence:
          </p>

          <div className="mt-5 flex flex-col items-center justify-center md:grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {scholarshipData.length > 0 ? (
              scholarshipData.map((scholarship, idx) => (
                <div key={idx} className="flip-card">
                  <div className="flip-card-inner">
                    <div className="flip-card-front">
                      <div>
                        <div>
                          <div className="bg-sdorange p-3 space-y-2">
                            <p className="font-bold">{scholarship.title}</p>
                            <p className="text-sm text-sdorange bg-sddarkgray p-1 rounded-md inline-block px-2 py-1">
                              {scholarship.status || "APPLICATION OPEN"}
                            </p>
                          </div>
                          <div className="space-y-4 p-4 flex flex-col justify-between">
                            <div className="flex justify-between w-full">
                              <div className="w-6/12 space-y-2">
                                <div className="flex items-center space-x-1">
                                  <img
                                    src="/image-fix/scholarship-icons/hugeicons_book-open-02.svg"
                                    alt="Program icon"
                                    className="w-5 h-auto"
                                  />
                                  <p className="font-semibold text-xs">
                                    PROGRAM
                                  </p>
                                </div>
                                <p className="text-sm font-light">
                                  {scholarship.program || "-"}
                                </p>
                              </div>
                              <div className="w-7/12 space-y-2">
                                <div className="flex items-center space-x-1">
                                  <img
                                    src="/image-fix/scholarship-icons/stash_graduation-cap.svg"
                                    alt="School icon"
                                    className="w-5 h-auto"
                                  />
                                  <p className="font-semibold text-xs">
                                    SCHOOL APPLICABLE
                                  </p>
                                </div>
                                <p className="text-sm font-light">
                                  {scholarship.school || "-"}
                                </p>
                              </div>
                            </div>
                            <div className="space-y-2">
                              <div className="flex items-center space-x-1">
                                <img
                                  src="/image-fix/scholarship-icons/fluent_tag-percent-28-regular.svg"
                                  alt="Value icon"
                                  className="w-5 h-auto"
                                />
                                <p className="text-xs font-semibold">VALUE</p>
                              </div>
                              <p className="text-sm font-light">
                                {scholarship.value
                                  ? `${scholarship.value}%`
                                  : "-"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flip-card-back">
                      <div>
                        <div className="bg-sdorange p-3 space-y-2">
                          <p className="font-bold text-sddarkgray">
                            Eligibility Criteria
                          </p>
                        </div>
                        <div className="p-4 space-y-2 text-sm flex flex-col justify-between bg-sddarkgray text-white">
                          {scholarship.eligibility &&
                          scholarship.eligibility.length > 0 ? (
                            scholarship.eligibility.map((criteria, i) => (
                              <div
                                key={i}
                                className="flex items-center space-x-2"
                              >
                                <img
                                  src="/image-fix/custom-icons/preferred-custom-pointer.svg"
                                  className="w-6 h-auto"
                                  alt="pointer icon"
                                />
                                <p>{criteria}</p>
                              </div>
                            ))
                          ) : (
                            <p>No eligibility criteria provided.</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-red-600">
                No scholarships available for this programme at the moment.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
